const API_BASE = process.env.REACT_APP_API_BASE || "https://www.smart-lend.com/api";

export default API_BASE;
